import React from 'react';
import LegalPage from './LegalPage';
import { termsContent } from '../data/legalContent';

const Terms = () => (
  <LegalPage title="Terms and Conditions" eyebrow="Metaxu One Private Limited" content={termsContent} />
);

export default Terms;
